enum PaymentMethodType {
  Card = 'CreditCard',
  Ach = 'Ach',
  Check = 'Check',
  Postpone = 'Postpone',
}
export default PaymentMethodType;
